// src/components/layout/Sidebar.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';
import { useMedicalCenter } from '../../context/MedicalCenterContext';
import { ROUTES } from '../../constants/routes';

const Sidebar = () => {
  const { sidebarItems } = usePermissions();
  const { medicalCenterId } = useMedicalCenter();
  const location = useLocation();

  const getRoute = (item) => {
    if (item === 'Medical Centers' || !medicalCenterId) return ROUTES.MEDICAL_CENTERS;
    const id = medicalCenterId;
    const map = {
      'Patients': ROUTES.PATIENTS(id),
      'Enrollments': ROUTES.ENROLLMENTS(id),
      'Call Sessions': ROUTES.CALL_SESSIONS(id),
      'Users': ROUTES.USERS(id),
      'Analytics': ROUTES.ANALYTICS(id),
    };
    return map[item] || '#';
  };

  const isActive = (route) => location.pathname === route;

  return (
    <div className="w-64 bg-blue-800 text-white flex flex-col">
      <nav className="p-4 flex-1">
        <ul className="space-y-2">
          {sidebarItems.map((item) => {
            const route = getRoute(item);
            return (
              <li key={item}>
                <Link
                  to={route}
                  className={`block px-4 py-3 rounded-lg transition-colors ${
                    isActive(route) ? 'bg-blue-600 text-white' : 'text-blue-100 hover:bg-blue-700 hover:text-white'
                  }`}
                >
                  {item}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;